import { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { getScormBlock } from 'api/lessons/block-instances/GetScormBlock'
import { Col } from 'react-bootstrap'
import Loader from 'components/ui/loader/Loader'
import Scorm from '../courses/lessons/components/LessonCard/components/ContentBlock/components/Scorm'
import { BlockScormContent } from 'store/states/lessons.state'

export const ScormPage = () => {
  const { id } = useParams<{ id: string }>()
  const [loading, setLoading] = useState(true)
  const [blockScorm, setBlockScorm] = useState<BlockScormContent>()

  useEffect(() => {
    getScormBlock(+id)
      .then((res) => {
        setBlockScorm(res)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [id])

  if (loading)
    return (
      <Col>
        <div className="d-flex justify-content-center">
          <Loader color />
        </div>
      </Col>
    )
  if (!blockScorm) return null
  return <Scorm data={blockScorm} buttons={false} canCloseWindow />
}

export default ScormPage
